import React, { Component } from 'react'
import ReactGA from 'react-ga'
import { ContentLoaderStyle } from './../styles'
import { Load } from './../components'
import { fetchPage } from './../services/ApiController'

export const withLoader = (WrappedComponent, path = null, slug = false, isReload = true) => {

  return class extends Component {
    state = {
      isReady: false
    }

    componentDidMount() {
      this.getData(this.props.location, this.props.match)
    }

    componentWillReceiveProps({match, location}) {
      if (window.location.pathname !== '/q-and-a') {
        if ( 
          this.props.location.pathname !== location.pathname && 
          ( match.path === this.props.match.path || (match.path.search('/catalog/models') !== -1 && 
          this.props.match.path.search('/class/') !== -1 )) &&
          isReload
          ) {
          this.setState({ isReady: false })
          this.getData(location, match)
        }
      }
    }

    getData = async (location, match) => {
      let fetchURL = !path ? location.pathname : path
      if (slug) fetchURL = `${path}/${match.params.slug}`

      await fetchPage(fetchURL, location ? location.search === '?preview=true' : false).then((data) => {
        this.setState({ isReady: true, data })
        ReactGA.pageview(fetchURL);
      }).catch((e) => {
        console.log('Something wrong with fetching data', e)
      })
    }
    
    render() {
      const { isReady } = this.state
      return (
        <div className={ContentLoaderStyle(isReady)}>
          <div className='content-loader'>
            <Load width={24} height={24} />
          </div>
          <WrappedComponent {...this.props} {...this.state} getData={this.getData} />
        </div>
      )
    }
  }
}


// WEBPACK FOOTER //
// ./src/hoc/withLoader.js